import { gql } from '@apollo/client';

export const SET_LATEST_UPDATE_GIFT = gql`
  mutation setLatestUpdateGift(
    $eligibleIosVersions: [Int!]!
    $eligibleAndroidVersions: [Int!]!
    $betaIosVersions: [Int!]
    $betaAndroidVersions: [Int!]
    $gift1Type: String!
    $gift1Amount: Int!
    $gift2Type: String!
    $gift2Amount: Int!
  ) {
    setLatestUpdateGift(
      eligibleIosVersions: $eligibleIosVersions
      eligibleAndroidVersions: $eligibleAndroidVersions
      betaIosVersions: $betaIosVersions
      betaAndroidVersions: $betaAndroidVersions
      gift1Type: $gift1Type
      gift1Amount: $gift1Amount
      gift2Type: $gift2Type
      gift2Amount: $gift2Amount
    ) {
      eligibleIosVersions
      eligibleAndroidVersions
      betaIosVersions
      betaAndroidVersions
      gift1Type
      gift1Amount
      gift2Type
      gift2Amount
      updatedAt
    }
  }
`;

export const GET_UPDATE_GIFT_HISTORY = gql`
  query updateGiftHistory($limit: Int) {
    updateGiftHistory(limit: $limit) {
      id
      appId
      eligibleIosVersions
      eligibleAndroidVersions
      betaIosVersions
      betaAndroidVersions
      gift1Type
      gift1Amount
      gift2Type
      gift2Amount
      createdAt
    }
  }
`;

export const UPDATE_UPDATE_GIFT_HISTORY = gql`
  mutation updateUpdateGiftHistory(
    $id: ID!
    $eligibleIosVersions: [Int!]
    $eligibleAndroidVersions: [Int!]
    $betaIosVersions: [Int!]
    $betaAndroidVersions: [Int!]
    $gift1Type: String
    $gift1Amount: Int
    $gift2Type: String
    $gift2Amount: Int
  ) {
    updateUpdateGiftHistory(
      id: $id
      eligibleIosVersions: $eligibleIosVersions
      eligibleAndroidVersions: $eligibleAndroidVersions
      betaIosVersions: $betaIosVersions
      betaAndroidVersions: $betaAndroidVersions
      gift1Type: $gift1Type
      gift1Amount: $gift1Amount
      gift2Type: $gift2Type
      gift2Amount: $gift2Amount
    ) {
      id
      eligibleIosVersions
      eligibleAndroidVersions
      betaIosVersions
      betaAndroidVersions
      gift1Type
      gift1Amount
      gift2Type
      gift2Amount
      createdAt
    }
  }
`;

export const DELETE_UPDATE_GIFT_HISTORY = gql`
  mutation deleteUpdateGiftHistory($id: ID!) {
    deleteUpdateGiftHistory(id: $id)
  }
`;
